import React from 'react'

import { Box, Button, Callout, RadioButton } from '@factorialco/deprecated-design-system'
import { TrainingsSessionUpdateStrategyEnum } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  onClose: () => void
  onSave: (strategy: TrainingsSessionUpdateStrategyEnum) => void
  onlyAllSessions?: boolean
  saveText: string
}
export const SessionSelectStrategyModal = ({
  title,
  onClose,
  onSave,
  saveText,
  onlyAllSessions,
}: Props) => {
  const initialStrategy = onlyAllSessions ? 'all' : 'individually'

  const [strategy, setStrategy] =
    React.useState<TrainingsSessionUpdateStrategyEnum>(initialStrategy)
  return (
    <Modal
      title={title}
      description=""
      footer={
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button
            onClick={() => {
              onSave(strategy)
              onClose()
            }}
          >
            {saveText}
          </Button>
        </Box>
      }
      onClose={onClose}
      onSubmit={() => onSave(strategy)}
    >
      <Box gap="s16">
        <Box gap="s16">
          <RadioButton
            label={i18n.t(
              'trainings.trainings_revamp.sessions.edit_session_modal.session_strategy_modal.individually'
            )}
            onChange={() => {
              setStrategy('individually')
            }}
            value="individually"
            checked={strategy === 'individually'}
            disabled={onlyAllSessions}
          />
          <RadioButton
            label={i18n.t(
              'trainings.trainings_revamp.sessions.edit_session_modal.session_strategy_modal.future'
            )}
            onChange={() => {
              setStrategy('future')
            }}
            value="future"
            checked={strategy === 'future'}
            disabled={onlyAllSessions}
          />
          <RadioButton
            label={i18n.t(
              'trainings.trainings_revamp.sessions.edit_session_modal.session_strategy_modal.all'
            )}
            onChange={() => {
              setStrategy('all')
            }}
            value="all"
            checked={strategy === 'all'}
          />
        </Box>
        {onlyAllSessions && (
          <Callout
            title={i18n.t(
              'trainings.trainings_revamp.sessions.edit_session_modal.session_strategy_modal.callout.title'
            )}
            description={i18n.t(
              'trainings.trainings_revamp.sessions.edit_session_modal.session_strategy_modal.callout.description'
            )}
            type="info"
          />
        )}
      </Box>
    </Modal>
  )
}
